export default __webpack_public_path__ + "static/media/watermark_logo.b12d4aa4.svg";